// src/services/adminApiService.js

const API_BASE_URL = process.env.REACT_APP_SERVER_API_URL || 'http://localhost:8080';

class AdminApiService {
  
  // Get all conversations
  async getAllConversations(filters = {}) {
    try {
      const params = new URLSearchParams();
      if (filters.status) params.append('status', filters.status);
      if (filters.limit) params.append('limit', filters.limit);
      
      const response = await fetch(`${API_BASE_URL}/api/firestore/sessions?${params}`);
      if (!response.ok) throw new Error('Failed to fetch conversations');
      
      const data = await response.json();
      return data.conversations;
    } catch (error) {
      console.error('Error fetching conversations:', error);
      throw error;
    }
  }
  
  // Get conversation metadata
  async getConversationMetadata(sessionId) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/firestore/sessions/${sessionId}`);
      if (!response.ok) throw new Error('Failed to fetch conversation metadata');
      
      return await response.json();
    } catch (error) {
      console.error('Error fetching metadata:', error);
      throw error;
    }
  }
  
  // Get all turns for a conversation
  async getConversationTurns(sessionId) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/firestore/sessions/${sessionId}/turns`);
      if (!response.ok) throw new Error('Failed to fetch turns');
      
      const data = await response.json();
      return data.turns;
    } catch (error) {
      console.error('Error fetching turns:', error);
      throw error;
    }
  }
  
  // Get reports for a specific turn
  async getTurnReports(sessionId, turnId) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/firestore/sessions/${sessionId}/turns/${turnId}/reports`);
      if (!response.ok) throw new Error('Failed to fetch reports');
      
      const data = await response.json();
      return data.reports;
    } catch (error) {
      console.error('Error fetching reports:', error);
      throw error;
    }
  }
  
  // Download file from server (✅ Fixed path - no /api prefix)
  async downloadFile(sessionId, turnNumber, filename) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/files/download/${sessionId}/${turnNumber}/${filename}`
      );
      if (!response.ok) throw new Error('Failed to download file');
      
      return await response.blob();
    } catch (error) {
      console.error('Error downloading file:', error);
      throw error;
    }
  }
  
  // Get signed URL for file preview (✅ Fixed path - no /api prefix)
  async getFileSignedUrl(sessionId, turnNumber, filename) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/files/signed-url/${sessionId}/${turnNumber}/${filename}`
      );
      if (!response.ok) throw new Error('Failed to get signed URL');
      
      const data = await response.json();
      return data.url;
    } catch (error) {
      console.error('Error getting signed URL:', error);
      throw error;
    }
  }
  
  // Search conversations
  async searchConversations(searchTerm) {
    try {
      // For now, fetch all and filter client-side
      // Later, you can implement server-side search
      const conversations = await this.getAllConversations();
      
      return conversations.filter(conv => 
        conv.chatName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        conv.sessionId?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    } catch (error) {
      console.error('Error searching conversations:', error);
      throw error;
    }
  }
}

export default new AdminApiService();
